import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { delay, forkJoin, switchMap } from 'rxjs';
import { LocalStorageService } from 'src/app/_services/localStorage/local-storage.service';
import { TableConfig } from 'src/app/interfaces/bl.interfaces';
import { BlService } from 'src/app/_services/bl/bl.service';
import { AbandonoPedimentoService } from 'src/app/_services/abandonoPedimento/abandono-pedimento.service';
import { ActiveCustom, Pedimento, PedimentoCreate, PedimentoFile } from 'src/app/interfaces/abandonosPedimentos.interfaces';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from 'src/app/_services/auth/auth.service';
import { CustomName, Material, MaterialGroup } from 'src/app/interfaces/lotes.interfaces';
import { LoteService } from 'src/app/_services/lote/lote.service';

interface infoLote {
  operationNumber:  string;
  id:               number;
}
/**
 * Componente de página que administra los pedimentos aduanales de un lote o
 * barco: lista, crea, edita, descarga y elimina registros de pedimento para
 * importación y exportación, gestionando rectificaciones y totales.
 */
@Component({
  selector: 'app-pedimento',
  templateUrl: './pedimento.component.html',
  styleUrls: ['./pedimento.componet.css']
})
export class PedimentoComponent implements OnInit {
  table_config: TableConfig = {
    tableHeads: [
      ['No. Patente aduanal', 'no_customs_patent'],
      ['Pedimento', 'number_customs_entry'],
      ['Toneladas liberadas', 'tons_released'],
      ['Piezas/Super sacos', 'big_bags'],
      ['Fecha', 'customs_entry_payment_date'],
      ['Agente aduanal', 'customs_agency'],
      ['Clave pedimento', 'custom_entry_key_description']
    ],
    tableHeadsContainer: ['Descargar', 'Editar', 'Eliminar'],
    styles: {
      table_heads: {
        'grid-template-columns': 'repeat(7, minmax(90px, 1fr)) minmax(200px, auto)',
        'min-width': '830px',
      },
      table_row: {
        'grid-template-columns': 'repeat(7, minmax(90px, 1fr)) minmax(200px, auto)',
        'min-width': '830px',
      },
      table_row_totals: {
        'grid-template-columns': 'repeat(7, minmax(90px, 1fr)) minmax(200px, auto)',
        'min-width': '830px',
        'background-color': '#455660',
        'color': '#fff',
      },
      container_icons: {
        'grid-template-columns': 'repeat(3, 1fr)',
      }
    },
    arrayFields: [
      'no_customs_patent',
      'number_customs_entry',
      'tons_released',
      'big_bags',
      'customs_entry_payment_date',
      'customs_agency',
      'custom_entry_key_description'
    ],
    iconos: [["/descargar-pedimento", "id", 'bi bi-download'], ["/actualizar-abandono", "id", 'bi bi-pencil-square'], ['/eliminar-abandono', "id", 'bi bi-trash3']],
    mensaje: "Sin pedimentos asignados.",
    filter: true,
    totals: {
      show: true,
      content: ['', 'Totales:', 'total', 'piezas', '', '', '',],
      total: 0,
      piezas: 0
    }
  };
  datosIncompletos: boolean = false;
  mensajeError: string = '';
  containerStyles = {
    'grid-template-columns': 'repeat(2, 1fr)'
  };
  loader: boolean = false;
  loteEliminar: boolean = false;
  infoLote: infoLote = {
    operationNumber: '',
    id: 0,
  }
  titulo: string = '';
  showAbandonoForm: boolean = false;
  pedimentoForm: FormGroup;

  overlayError: boolean = false;
  mensaje: string = '';
  confirmacion: boolean = false;
  pedimentoCreate: PedimentoCreate = {
    no_customs_patent: 0,
    number_customs_entry: 0,
    tons_released: 0,
    big_bags: 0,
    customs_entry_payment_date: '',
    customs_agency: '',
    customs_entry_key: 0,
    name_customs_entry_document: '',
    modulation_status: 0,
    user_create_id: '',
    user_update_id: '',
    batch_id: 0,
    ship_number: 0
  };
  currentPedimento: Pedimento = {
    no_customs_patent: 0,
    number_customs_entry: '',
    tons_released: 0,
    big_bags: 0,
    customs_entry_payment_date: '',
    customs_agency: '',
    customs_entry_key: '',
    name_customs_entry_document: '',
    user_create_id: '',
    user_update_id: '',
    registry_number: 0,
    modulation_status: '',
    batch_id: 0,
    custom_entry_tons_released: 0,
    id: 0,
    custom_entry_key_description: '',
    modulation_status_description: '',
    commercial_value: 0,
    current_id: 0,
    request_type_id: 0,
    old_id: 0,
    active: true,
    ship_number: 0
  };
  mensajeExito: string = '';
  informacionGuardada: boolean = false;
  pedimentoFile: PedimentoFile = {
    id_customs_entry: 0,
  };
  pedimentoFileUrl: string = '';
  pedimentoId: number = 0;
  filerError: boolean = false;
  loteId: number = 0;
  loading: boolean = false;
  errorMessage: string = 'Ingrese el oficio de pedimento';
  modulationStatus: MaterialGroup[] = [];
  requestType: MaterialGroup[] = [];
  keyList: MaterialGroup[] = [];
  allKeyList: MaterialGroup[] = [];
  customNameList: CustomName[] = [];
  missingAgent: boolean = false;
  activeCustomLoader: boolean = false;
  activeCustomList: ActiveCustom[] = [];
  togleActives: number = 1;
  rectifiedCustom: string = '';
  active: boolean = true;
  shipId: number = 0;
  showCurrendId: boolean = false;

  get pedimentos() {
    return this.pedimentoService.pedimentosFilter;
  }

  constructor(
    private loteService: LoteService,
    private authService: AuthService,
    private fb: FormBuilder,
    private blServices: BlService,
    private localStorageService: LocalStorageService,
    private pedimentoService: AbandonoPedimentoService,
    private activatedRoute: ActivatedRoute,
    private router: Router
  ) {
    this.pedimentoForm = this.fb.group({
      no_customs_patent: [, [Validators.required]],
      number_customs_entry: [, [Validators.required, Validators.maxLength(15), Validators.minLength(4), Validators.pattern(/^[0-9]\d{0,29}$/)]],
      tons_released: [, [Validators.required, Validators.pattern(/^(?!0\d)\d{0,11}(?:\.\d{1,3})?$/)]],
      big_bags: [, [Validators.pattern(/^\d{1,11}$/)]],
      customs_entry_payment_date: [, [Validators.required]],
      customs_agency: [, [Validators.required, Validators.maxLength(100)]],
      customs_entry_key: ['', [Validators.required]],
      modulation_status: ['', [Validators.required]],
      custom_entry_tons_released: [, [Validators.required, Validators.pattern(/^(?!0\d)\d{0,11}(?:\.\d{1,3})?$/)]],
      name_customs_entry_document: [],
      file: [],

      current_id: [''],
      request_type_id: [''],
      commercial_value: [, [Validators.required, Validators.pattern(/^[0-9]{1,14}(\.[0-9]{1,2})?$/)]],

      hasCustom: [],
    });
  }

  ngOnInit(): void {
    this.blServices.path = '';
    this.loteId = Number(this.activatedRoute.snapshot.paramMap.get('batchId'));
    this.pedimentoCreate.user_create_id = this.localStorageService.getData('userEmail');
    this.pedimentoCreate.user_update_id = this.localStorageService.getData('userEmail');
    this.loader = true;
    forkJoin([this.loteService.getModulationStatus(), this.pedimentoService.getCustomKeyList(), this.loteService.getCustomNameList(), this.pedimentoService.getCustomRequestType()])
    .subscribe({
      next: ([modulationStatus, keyList, customNameList, requestType]) => {
        this.modulationStatus = this.sortArray<MaterialGroup>(modulationStatus, 'description');
        this.requestType = this.sortArray<MaterialGroup>(requestType, 'description');
        this.allKeyList = this.sortArray<MaterialGroup>(keyList, 'description');
        this.keyList = this.sortArray<MaterialGroup>(keyList, 'description');
        this.customNameList = customNameList;
      },
      error: (e) => {
        this.loader = false;
        this.overlayError = true;
      },
    });
    if (this.router.url.includes('exportation')) {
      this.shipId = Number(this.activatedRoute.snapshot.paramMap.get('shipId'));
      this.pedimentoService.getExportPedimentoListByShip(this.shipId)
      .subscribe({
        next: (pedimentos) => {
          pedimentos = this.pedimentoDateFormat(pedimentos);
          this.updateTotals(pedimentos);
          this.pedimentoService.pedimentos = [...pedimentos];
          this.pedimentoService.pedimentosFilter = [...pedimentos];
          this.loader = false;
        },
        error: (e) => {
          this.loader = false;
          this.overlayError = true;
        },
      });
    } else {
      this.pedimentoService.getPedimentoListByBatch(this.loteId)
      .subscribe({
        next: (pedimentos) => {
          pedimentos = this.pedimentoDateFormat(pedimentos);
          this.updateTotals(pedimentos);
          this.pedimentoService.pedimentos = [...pedimentos];
          this.pedimentoService.pedimentosFilter = [...pedimentos];
          this.loader = false;
        },
        error: (e) => {
          this.loader = false;
          this.overlayError = true;
        },
      });
    }

    this.pedimentoForm.get('hasCustom')?.valueChanges.subscribe(value => {
      this.pedimentoForm.get('current_id')?.setValue('');
      this.pedimentoForm.get('current_id')?.clearValidators();
      this.showCurrendId = value;
      if (value && this.titulo.includes('Crear')) {
        this.pedimentoForm.get('current_id')?.addValidators([Validators.required]);
      }
      this.pedimentoForm.get('current_id')?.updateValueAndValidity();
    })
  }

  /**
   * Valida los permisos y abre el formulario para crear un nuevo registro de pedimento.
   */
  mostrarAbandonoForm() {
    if (this.router.url.includes('exportation')) {
      if (!this.authService.isValidPath('export', 'customs', 'create')) {
        return;
      }
    } else {
      if (!this.authService.isValidPath('import', 'customs', 'create')) {
        return;
      }
    }
    this.titulo = 'Crear Registro de Pedimento';
    this.pedimentoFileUrl = '';
    this.rectifiedCustom = '';
    this.active = true;
    this.pedimentoForm.reset();
    this.pedimentoForm.get('file')?.addValidators([Validators.required]);
    this.pedimentoForm.get('no_customs_patent')?.setValue('');
    this.pedimentoForm.get('customs_entry_key')?.setValue('');
    this.pedimentoForm.get('modulation_status')?.setValue('');
    this.pedimentoForm.get('big_bags')?.setValue(0);
    this.pedimentoForm.get('no_customs_patent')?.disable();
    this.pedimentoForm.get('customs_agency')?.disable();
    this.pedimentoForm.get('customs_entry_key')?.enable();
    this.pedimentoForm.get('request_type_id')?.enable();
    this.keyList = [...this.allKeyList];
    this.toggleOverlay();
  }

  /**
   * Alterna la visibilidad del formulario de pedimento.
   */
  toggleOverlay() {
    this.showAbandonoForm = !this.showAbandonoForm;
  }

  /**
   * Define el mensaje de confirmación según la acción (crear, rectificar o editar) y muestra el diálogo.
   */
  confirmPedimentoForm() {
    if (this.titulo.includes('Crear')) {
      const customs_entry_key = this.pedimentoForm.get('customs_entry_key')?.value;
      const current_id = this.pedimentoForm.get('current_id')?.value;
      this.mensaje = customs_entry_key == '4' && current_id ?
      '¿Está seguro de rectificar el pedimento? Esta acción inactivará el pedimento y todos los registros relacionados con él serán actualizados por el nuevo.' :
      '¿Está seguro de agregar el pedimento?';
    }
    if (this.titulo.includes('Editar')) {
      this.mensaje = '¿Está seguro de editar el registro de este pedimento?';
    }
    this.confirmacion = true;
  }

  /**
   * Valida permisos, carga los datos del pedimento seleccionado en el formulario y descarga su archivo para edición.
   * @param idPedimento - Identificador del pedimento a editar.
   */
  mostrarActualizar(idPedimento: number) {
    if (this.router.url.includes('exportation')) {
      if (!this.authService.isValidPath('export', 'customs', 'update')) {
        return;
      }
    } else {
      if (!this.authService.isValidPath('import', 'customs', 'update')) {
        return;
      }
    }
    this.titulo = 'Editar Pedimento';
    this.pedimentoForm.get('file')?.clearValidators();
    this.currentPedimento = this.pedimentos.find( pedimento => pedimento.id == idPedimento ) || this.currentPedimento;
    this.active = this.currentPedimento?.active || false;
    this.pedimentoForm.reset({
      no_customs_patent: this.currentPedimento?.no_customs_patent,
      number_customs_entry: this.currentPedimento?.number_customs_entry,
      tons_released: this.currentPedimento?.tons_released,
      big_bags: this.currentPedimento?.big_bags,
      customs_entry_payment_date: this.currentPedimento?.customs_entry_payment_date.substring(0,10),
      customs_agency: this.currentPedimento?.customs_agency,
      customs_entry_key: this.currentPedimento?.customs_entry_key,
      name_customs_entry_document: this.currentPedimento?.name_customs_entry_document,
      modulation_status: this.currentPedimento?.modulation_status,
      custom_entry_tons_released: this.currentPedimento?.custom_entry_tons_released,
      commercial_value: this.currentPedimento?.commercial_value,
      current_id: this.currentPedimento?.current_id,
      request_type_id: this.currentPedimento?.request_type_id,
    });
    this.pedimentoCreate = {
      ...this.pedimentoCreate,
      ...this.pedimentoForm.value,
      no_customs_patent: this.currentPedimento?.no_customs_patent,
    };
    this.togleCustomKey();
    if (Number(this.pedimentoForm.get('customs_entry_key')?.value) === 4) {
      this.keyList = [...this.allKeyList];
      this.pedimentoForm.get('customs_entry_key')?.disable();
      this.pedimentoForm.get('request_type_id')?.disable();
      const oldCustom = this.pedimentoService.pedimentos.find( custom => custom.id === this.currentPedimento?.old_id);
      this.rectifiedCustom = `${oldCustom?.number_customs_entry || 'No encontrado.'}`;
      this.pedimentoForm.get('current_id')?.clearValidators();
      this.pedimentoForm.get('current_id')?.updateValueAndValidity();
    } else {
      this.pedimentoForm.get('customs_entry_key')?.enable();
      this.keyList = this.allKeyList.filter( key => key.id !== 4);
      this.rectifiedCustom = '';
    }
    this.pedimentoForm.get('no_customs_patent')?.disable();
    this.pedimentoForm.get('customs_agency')?.disable();
    delete this.pedimentoFile.file;
    this.pedimentoFile.id_customs_entry = this.currentPedimento!.id;
    if (this.router.url.includes('exportation')) {
      this.pedimentoService.downloadExportPedimento(this.pedimentoFile)
      .subscribe({
        next: pedimento => this.pedimentoFileUrl = pedimento.url,
        error: (e) => {
          this.datosIncompletos = true;
          this.mensajeError = 'Error en el servidor al descargar el archivo, inténtelo más tarde';
          setTimeout(() => {
            this.datosIncompletos = false;
          }, 3000);
        },
      });
    } else {
      this.pedimentoService.downloadPedimento(this.pedimentoFile)
      .subscribe({
        next: pedimento => this.pedimentoFileUrl = pedimento.url,
        error: (e) => {
          this.datosIncompletos = true;
          this.mensajeError = 'Error en el servidor al descargar el archivo, inténtelo más tarde';
          setTimeout(() => {
            this.datosIncompletos = false;
          }, 3000);
        },
      });
    }
    this.showAbandonoForm = true;
  }

  /**
   * Valida el formulario y crea o actualiza el pedimento (importación o exportación), refrescando la lista al finalizar.
   * @param cancelar - Cadena no vacía cuando el usuario cancela la operación.
   */
  guardar(cancelar: string) {
    this.confirmacion = false;
    if (cancelar) {
      return;
    }
    if (!this.active) {
      this.mensajeError = 'Solo se pueden actualizar los pedimentos activos';
      this.datosIncompletos = true;
      setTimeout(() => {
        this.datosIncompletos = false;
      }, 4000);
      return;
    }
    if( this.pedimentoForm.invalid || this.missingAgent ) {
      this.pedimentoForm.markAllAsTouched();
      this.mensajeError = 'Favor de verificar la información';
      this.datosIncompletos = true;
      setTimeout(() => {
        this.datosIncompletos = false;
      },2000);
      return;
    }
    if ( Number(this.pedimentoForm.get('tons_released')?.value) === 0 ) {
      this.mensajeError = 'Toneladas liberadas no debe ser 0';
      this.datosIncompletos = true;
      setTimeout(() => {
        this.datosIncompletos = false;
      },3000);
      return;
    }
    let currentActiveCustom;
    if (Number(this.pedimentoForm.get('current_id')?.value)) {
      currentActiveCustom = this.activeCustomList.find( activeCustom => activeCustom.id === Number(this.pedimentoForm.get('current_id')?.value) );
    }
    if (this.titulo.includes('Crear')) {
      delete this.pedimentoCreate.id;
      this.pedimentoCreate = {
        ...this.pedimentoCreate,
        ...this.pedimentoForm.value,
        custom_entry_tons_released: this.pedimentoForm.get('custom_entry_tons_released')?.value ? Number(this.pedimentoForm.get('custom_entry_tons_released')?.value) : null,
        number_customs_entry: Number(this.pedimentoForm.get('number_customs_entry')?.value),
        tons_released: Number(this.pedimentoForm.get('tons_released')?.value),
        big_bags: Number(this.pedimentoForm.get('big_bags')?.value),
        modulation_status: Number(this.pedimentoForm.get('modulation_status')?.value),
        customs_entry_key: Number(this.pedimentoForm.get('customs_entry_key')?.value),
        customs_agency: this.pedimentoForm.get('customs_agency')?.value,
        batch_id: this.loteId,
        commercial_value: Number(this.pedimentoForm.get('commercial_value')?.value),
        current_id: Number(this.pedimentoForm.get('current_id')?.value) || null,
        request_type_id: Number(this.pedimentoForm.get('request_type_id')?.value) || null,
        number_customs_entry_old: currentActiveCustom?.number_customs_entry || null
      };
      this.loading = true;
      if (this.router.url.includes('exportation')) {
        this.pedimentoCreate.batch_id = null;
        this.pedimentoCreate.ship_number = this.shipId;
        this.pedimentoService.createExportPedimento(this.pedimentoCreate)
        .subscribe({
          next: response => {
            this.loading = false;
            if (response.error) {
              this.mensajeError = response.message.includes('tonnage')
              ? 'La suma de toneladas liberadas es mayor a la suma de toneladas de entrada'
              : response.message.includes('pieces')
              ? 'La suma de piezas es mayor a las piezas totales del lote'
              : 'Lo sentimos no fue posible agregar el pedimento, inténtelo más tarde';
              this.datosIncompletos = true;
              setTimeout(() => {
                this.datosIncompletos = false;
              }, 4000);
              return;
            }
            this.mensajeExito = 'El pedimento fue agregado correctamente';
            this.informacionGuardada = true;
            this.loader = true;
            this.pedimentoService.getExportPedimentoListByShip(this.shipId)
            .subscribe({
              next: (pedimentos) => {
                setTimeout(() => {
                  pedimentos = this.pedimentoDateFormat(pedimentos);
                  this.pedimentoService.pedimentos = [...pedimentos];
                  this.pedimentoService.pedimentosFilter = [...pedimentos];
                  this.sortCustoms();
                  this.informacionGuardada = false;
                  this.showAbandonoForm = false;
                  this.loader = false;
                }, 2000);
              },
              error: (e) => {
                this.informacionGuardada = false;
                this.showAbandonoForm = false;
                this.loader = false;
                this.overlayError = true;
              },
            });
          },
          error: (e) => {
            this.loader = false;
            this.informacionGuardada = false;
            this.showAbandonoForm = false;
            this.datosIncompletos = true;
            this.mensajeError = 'Error en el servidor al crear registro, inténtelo más tarde';
            setTimeout(() => {
              this.datosIncompletos = false;
            }, 3000);
          },
        });
      } else {
        this.pedimentoService.createPedimento(this.pedimentoCreate)
        .subscribe({
          next: response => {
            this.loading = false;
            if (response.error) {
              this.mensajeError = response.message.includes('tonnage')
              ? 'La suma de toneladas liberadas es mayor a la suma de toneladas de entrada'
              : response.message.includes('pieces')
              ? 'La suma de piezas es mayor a las piezas totales del lote'
              : 'Lo sentimos no fue posible agregar el pedimento, inténtelo más tarde';
              this.datosIncompletos = true;
              setTimeout(() => {
                this.datosIncompletos = false;
              }, 4000);
              return;
            }
            this.mensajeExito = 'El pedimento fue agregado correctamente';
            this.informacionGuardada = true;
            this.loader = true;
            this.pedimentoService.getPedimentoListByBatch(this.loteId)
            .subscribe({
              next: (pedimentos) => {
                setTimeout(() => {
                  pedimentos = this.pedimentoDateFormat(pedimentos);
                  this.pedimentoService.pedimentos = [...pedimentos];
                  this.pedimentoService.pedimentosFilter = [...pedimentos];
                  this.sortCustoms();
                  this.informacionGuardada = false;
                  this.showAbandonoForm = false;
                  this.loader = false;
                }, 2000);
              },
              error: (e) => {
                this.informacionGuardada = false;
                this.showAbandonoForm = false;
                this.loader = false;
                this.overlayError = true;
              },
            });
          },
          error: (e) => {
            this.loader = false;
            this.informacionGuardada = false;
            this.showAbandonoForm = false;
            this.datosIncompletos = true;
            this.mensajeError = 'Error en el servidor al crear el registro, inténtelo más tarde';
            setTimeout(() => {
              this.datosIncompletos = false;
            }, 3000);
          },
        });
      }
    } else {
      this.pedimentoCreate = {
        ...this.pedimentoCreate,
        ...this.pedimentoForm.value,
        number_customs_entry: Number(this.pedimentoForm.get('number_customs_entry')?.value),
        tons_released: Number(this.pedimentoForm.get('tons_released')?.value),
        big_bags: Number(this.pedimentoForm.get('big_bags')?.value),
        user_update_id: this.localStorageService.getData('userEmail'),
        batch_id: this.loteId,
        file: this.pedimentoForm.get('file')?.value ? this.pedimentoForm.get('file')?.value : '',
        id: this.pedimentoFile.id_customs_entry,
        modulation_status: Number(this.pedimentoForm.get('modulation_status')?.value),
        customs_entry_key: Number(this.pedimentoForm.get('customs_entry_key')?.value),
        customs_agency: this.pedimentoForm.get('customs_agency')?.value,
        custom_entry_tons_released: this.pedimentoForm.get('custom_entry_tons_released')?.value ? Number(this.pedimentoForm.get('custom_entry_tons_released')?.value) : null,
        commercial_value: Number(this.pedimentoForm.get('commercial_value')?.value),
        current_id: Number(this.pedimentoForm.get('current_id')?.value) || null,
        request_type_id: Number(this.pedimentoForm.get('request_type_id')?.value) || null,
        number_customs_entry_old: currentActiveCustom?.number_customs_entry || null
      };
      this.loading = true;
      if (this.router.url.includes('exportation')) {
        this.pedimentoCreate.batch_id = this.currentPedimento.batch_id;
        this.pedimentoCreate.ship_number = this.currentPedimento.ship_number;
        this.pedimentoService.updateExportPedimento(this.pedimentoCreate)
        .subscribe({
          next: response => {
            this.loading = false;
            if (response.error) {
              this.mensajeError = response.message.includes('tonnage')
              ? 'La suma de toneladas liberadas es mayor a la suma de toneladas de entrada'
              : response.message.includes('pieces')
              ? 'La suma de piezas es mayor a las piezas totales del lote'
              : 'Lo sentimos no fue posible agregar el pedimento, inténtelo más tarde';
              this.datosIncompletos = true;
              setTimeout(() => {
                this.datosIncompletos = false;
              }, 4000);
              return;
            }
            this.mensajeExito = 'El pedimento fue actualizado correctamente';
            this.informacionGuardada = true;
            this.loader = true;
            this.pedimentoService.getExportPedimentoListByShip(this.shipId)
            .subscribe({
              next: (pedimentos) => {
                setTimeout(() => {
                  pedimentos = this.pedimentoDateFormat(pedimentos);
                  if (this.pedimentoFile.file) {
                    this.pedimentoService.pedimentos = [...pedimentos];
                    this.pedimentoService.pedimentosFilter = [...pedimentos];
                    this.sortCustoms();
                    this.informacionGuardada = false;
                    this.showAbandonoForm = false;
                    this.loader = false;
                  } else {
                    this.pedimentoService.pedimentos = [...pedimentos];
                    this.pedimentoService.pedimentosFilter = [...pedimentos];
                    this.sortCustoms();
                    this.informacionGuardada = false;
                    this.showAbandonoForm = false;
                    this.loader = false;
                  }
                }, 2000);
              },
              error: (e) => {
                this.informacionGuardada = false;
                this.showAbandonoForm = false;
                this.loader = false;
                this.overlayError = true;
              },
            });
          },
          error: (e) => {
            this.loader = false;
            this.informacionGuardada = false;
            this.showAbandonoForm = false;
            this.datosIncompletos = true;
            this.mensajeError = 'Error en el servidor al actualizar el registro, inténtelo más tarde';
            setTimeout(() => {
              this.datosIncompletos = false;
            }, 3000);
          },
        });
      } else {
        this.pedimentoService.updatePedimento(this.pedimentoCreate)
        .subscribe({
          next: response => {
            this.loading = false;
            if (response.error) {
              this.mensajeError = response.message.includes('tonnage')
              ? 'La suma de toneladas liberadas es mayor a la suma de toneladas de entrada'
              : response.message.includes('pieces')
              ? 'La suma de piezas es mayor a las piezas totales del lote'
              : 'Lo sentimos no fue posible actualizar el pedimento, inténtelo más tarde';
              this.datosIncompletos = true;
              setTimeout(() => {
                this.datosIncompletos = false;
              }, 4000);
              return;
            }
            this.mensajeExito = 'El pedimento fue actualizado correctamente';
            this.informacionGuardada = true;
            this.loader = true;
            this.pedimentoService.getPedimentoListByBatch(this.loteId)
            .subscribe({
              next: (pedimentos) => {
                setTimeout(() => {
                  pedimentos = this.pedimentoDateFormat(pedimentos);
                  if (this.pedimentoFile.file) {
                    this.pedimentoService.pedimentos = [...pedimentos];
                    this.pedimentoService.pedimentosFilter = [...pedimentos];
                    this.sortCustoms();
                    this.informacionGuardada = false;
                    this.showAbandonoForm = false;
                    this.loader = false;
                  } else {
                    this.pedimentoService.pedimentos = [...pedimentos];
                    this.pedimentoService.pedimentosFilter = [...pedimentos];
                    this.sortCustoms();
                    this.informacionGuardada = false;
                    this.showAbandonoForm = false;
                    this.loader = false;
                  }
                }, 2000);
              },
              error: (e) => {
                this.informacionGuardada = false;
                this.showAbandonoForm = false;
                this.loader = false;
                this.overlayError = true;
              },
            });
          },
          error: (e) => {
            this.loader = false;
            this.informacionGuardada = false;
            this.showAbandonoForm = false;
            this.datosIncompletos = true;
            this.mensajeError = 'Error en el servidor al actualizar el registro, inténtelo más tarde';
            setTimeout(() => {
              this.datosIncompletos = false;
            }, 3000);
          },
        });
      }
    }
  }

  /**
   * Valida permisos y, si el pedimento está activo, prepara su eliminación.
   * @param idPedimento - Identificador del pedimento a eliminar.
   */
  confirm(idPedimento: number) {
    if (this.router.url.includes('exportation')) {
      if (!this.authService.isValidPath('export', 'customs', 'delete')) {
        return;
      }
    } else {
      if (!this.authService.isValidPath('import', 'customs', 'delete')) {
        return;
      }
    }
    const pedimento = this.pedimentos.find( pedimento => pedimento.id == idPedimento );
    this.active = pedimento?.active || false;
    if (!this.active) {
      this.mensajeError = 'Solo se pueden eliminar los pedimentos activos';
      this.datosIncompletos = true;
      setTimeout(() => {
        this.datosIncompletos = false;
      }, 4000);
      return;
    }
    this.pedimentoId = idPedimento;
    this.loteEliminar = true;
  }

  /**
   * Elimina el pedimento seleccionado (importación o exportación) y refresca la lista, salvo que la operación se cancele.
   * @param cancelar - Cadena no vacía cuando el usuario cancela la eliminación.
   */
  deleteLote( cancelar: string ) {
    if ( cancelar ) {
      this.loteEliminar = false;
      return;
    }
    if (this.router.url.includes('exportation')) {
      this.pedimentoService.deleteExportPedimento({ id_customs_entry: this.pedimentoId })
      .subscribe({
        next: response => {
          this.loteEliminar = false;
          if (response.error) {
            this.mensajeError = 'Error al eliminar, el pedimento tiene salidas asignadas';
            this.datosIncompletos = true;
            setTimeout(() => {
              this.datosIncompletos = false;
            }, 4000);
            return;
          }
          this.mensajeExito = 'El pedimento fue eliminado correctamente';
          this.informacionGuardada = true;
          this.loader = true;
          this.pedimentoService.getExportPedimentoListByShip(this.shipId)
          .subscribe({
            next: (pedimentos) => {
              pedimentos = this.pedimentoDateFormat(pedimentos);
              this.pedimentoService.pedimentos = [...pedimentos];
              this.pedimentoService.pedimentosFilter = [...pedimentos];
              this.sortCustoms();
              setTimeout(() => {
                this.informacionGuardada = false;
                this.showAbandonoForm = false;
                this.loader = false;
              }, 2000);
            },
            error: (e) => {
              this.informacionGuardada = false;
              this.showAbandonoForm = false;
              this.loader = false;
              this.overlayError = true;
            },
          });
        },
        error: (e) => {
          this.loader = false;
          this.loteEliminar = false;
          this.showAbandonoForm = false;
          this.datosIncompletos = true;
          this.mensajeError = 'Error en el servidor al eliminar el registro, inténtelo más tarde';
          setTimeout(() => {
            this.datosIncompletos = false;
          }, 3000);
        },
      });
    } else {
      this.pedimentoService.deletePedimento({ id_customs_entry: this.pedimentoId })
      .subscribe({
        next: response => {
          this.loteEliminar = false;
          if (response.error) {
            this.mensajeError = 'Error al eliminar, el pedimento tiene salidas asignadas';
            this.datosIncompletos = true;
            setTimeout(() => {
              this.datosIncompletos = false;
            }, 4000);
            return;
          }
          this.mensajeExito = 'El pedimento fue eliminado correctamente';
          this.informacionGuardada = true;
          this.loader = true;
          this.pedimentoService.getPedimentoListByBatch(this.loteId)
          .subscribe({
            next: (pedimentos) => {
              pedimentos = this.pedimentoDateFormat(pedimentos);
              this.pedimentoService.pedimentos = [...pedimentos];
              this.pedimentoService.pedimentosFilter = [...pedimentos];
              this.sortCustoms();
              setTimeout(() => {
                this.informacionGuardada = false;
                this.showAbandonoForm = false;
                this.loader = false;
              }, 2000);
            },
            error: (e) => {
              this.informacionGuardada = false;
              this.showAbandonoForm = false;
              this.loader = false;
              this.overlayError = true;
            },
          });
        },
        error: (e) => {
          this.loader = false;
          this.loteEliminar = false;
          this.showAbandonoForm = false;
          this.datosIncompletos = true;
          this.mensajeError = 'Error en el servidor al eliminar el registro, inténtelo más tarde';
          setTimeout(() => {
            this.datosIncompletos = false;
          }, 3000);
        },
      });
    }
  }

  /**
   * Descarga el archivo del pedimento indicado y lo abre en una nueva pestaña.
   * @param idPedimento - Identificador del pedimento cuyo archivo se descarga.
   */
  downloadPedimento(idPedimento: number) {
    if (this.router.url.includes('exportation')) {
      this.pedimentoService.downloadExportPedimento({id_customs_entry: idPedimento})
      .subscribe({
        next: pedimento => {
          if (pedimento.url) {
            window.open(pedimento.url, '_blank')
          } else {
            this.filerError = true;
            setTimeout(() => {
              this.filerError = false;
            }, 2000);
          }
        },
        error: (e) => {
          this.datosIncompletos = true;
          this.mensajeError = 'Error en el servidor al descargar el archivo, inténtelo más tarde';
          setTimeout(() => {
            this.datosIncompletos = false;
          }, 3000);
        },
      });
    } else {
      this.pedimentoService.downloadPedimento({id_customs_entry: idPedimento})
      .subscribe({
        next: pedimento => {
          if (pedimento.url) {
            window.open(pedimento.url, '_blank')
          } else {
            this.filerError = true;
            setTimeout(() => {
              this.filerError = false;
            }, 2000);
          }
        },
        error: (e) => {
          this.datosIncompletos = true;
          this.mensajeError = 'Error en el servidor al descargar el archivo, inténtelo más tarde';
          setTimeout(() => {
            this.datosIncompletos = false;
          }, 3000);
        },
      });
    }
  }

  /**
   * Indica si un campo del formulario es inválido y ha sido tocado.
   * @param campo - Nombre del campo a evaluar.
   * @returns `true` si el campo tiene errores y fue tocado; en caso contrario `null` o `false`.
   */
  campoEsValido( campo: string): boolean | null {
    return this.pedimentoForm.get(campo)!.errors &&
    this.pedimentoForm.get(campo)!.touched;
  }

  /**
   * Procesa el archivo seleccionado, lo valida por tamaño y lo convierte a base64 para enviarlo.
   * @param event - Evento del input de archivo.
   * @param campo - Nombre del campo del formulario asociado al archivo.
   */
  fileInput(event: any, campo: string): void {
    if (event.target.files[0]) {
      if (event.target.files[0].size > 10 * 1024 * 1024) {
        this.errorMessage = 'El archivo debe ser menor a 10 mb';
        this.pedimentoForm.get('file')?.setValue('');
        delete this.pedimentoFile.file;
        return;
      }
      const file = event.target.files[0];
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        const cadena = reader.result?.toString() || '';
        const contenidoBase64 = cadena.split(',')[1];
        this.pedimentoFile.file = contenidoBase64;
        this.pedimentoForm.get('file')?.setValue(contenidoBase64);
      }
    } else {
      this.errorMessage = 'Ingrese el oficio de pedimento';
      this.pedimentoForm.get('file')?.setValue('');
      delete this.pedimentoFile.file;
    }
  }

  /**
   * Deriva el número de patente aduanal a partir del número de pedimento y asigna el agente aduanal correspondiente.
   */
  noPatentValue() {
    if (!this.pedimentoForm.get('number_customs_entry')?.hasError('pattern')) {
      const no_customs_patent: string = this.pedimentoForm.get('number_customs_entry')?.value.substring(0,4);
      this.pedimentoForm.get('no_customs_patent')?.setValue(no_customs_patent);
      this.pedimentoCreate.no_customs_patent = Number(no_customs_patent);
      this.pedimentoForm.get('customs_agency')?.setValue('');
      if (no_customs_patent.length === 4) {
        const custosAgent = this.customNameList.find( customName => customName.custom_number_name_key === Number(no_customs_patent));
        if (custosAgent) {
          this.pedimentoForm.get('customs_agency')?.setValue(custosAgent.description);
          this.missingAgent = false;
        } else {
          this.missingAgent = true;
        }
      }
    }
  }

  /**
   * Ajusta validadores y carga la lista de pedimentos activos cuando la clave de pedimento corresponde a una rectificación (clave 4).
   */
  togleCustomKey() {
    let currentCustomKey = Number(this.pedimentoForm.get('customs_entry_key')?.value);
    this.pedimentoForm.get('current_id')?.setValue('');
    this.pedimentoForm.get('current_id')?.clearValidators();
    this.pedimentoForm.get('request_type_id')?.clearValidators();
    this.pedimentoForm.get('hasCustom')?.setValue(false);
    if (currentCustomKey && currentCustomKey === 4) {
      if (this.titulo.includes('Editar')) {
        this.showCurrendId = true;
      }
      // this.pedimentoForm.get('current_id')?.addValidators([Validators.required]);
      this.pedimentoForm.get('request_type_id')?.addValidators([Validators.required]);
      this.activeCustomLoader = true;
      if (this.router.url.includes('exportation')) {
        this.pedimentoService.getExportActiveCustomList(this.shipId)
        .subscribe({
          next: activeCustomList => {
            this.activeCustomLoader = false;
            this.activeCustomList = [...activeCustomList.filter(custom => {
              if (this.titulo.includes('Editar') && this.currentPedimento.id) {
                return custom.id !== this.currentPedimento.id;
              } else {
                return true;
              }
            })];
          },
          error: (e) => {
            this.datosIncompletos = true;
            this.mensajeError = 'Error en el servidor al cargar las claves de pedimentos, inténtelo más tarde';
            setTimeout(() => {
              this.datosIncompletos = false;
            }, 3000);
          },
        });
      } else {
        this.pedimentoService.getActiveCustomList(this.loteId)
        .subscribe({
          next: activeCustomList => {
            this.activeCustomLoader = false;
            this.activeCustomList = [...activeCustomList.filter(custom => {
              if (this.titulo.includes('Editar') && this.currentPedimento.id) {
                return custom.id !== this.currentPedimento.id;
              } else {
                return true;
              }
            })];
          },
          error: (e) => {
            this.datosIncompletos = true;
            this.mensajeError = 'Error en el servidor al cargar las claves de pedimentos, inténtelo más tarde';
            setTimeout(() => {
              this.datosIncompletos = false;
            }, 3000);
          },
        });
      }
    } else {
      this.pedimentoForm.get('request_type_id')?.setValue('');
    }
    this.pedimentoForm.get('current_id')?.updateValueAndValidity();
    this.pedimentoForm.get('request_type_id')?.updateValueAndValidity();
  }

  /**
   * Normaliza el formato de la fecha de pago de cada pedimento a `AAAA-MM-DD`.
   * @param pedimentos - Lista de pedimentos a formatear.
   * @returns La lista de pedimentos con la fecha formateada.
   */
  pedimentoDateFormat(pedimentos: Pedimento[]): Pedimento[] {
    return pedimentos.map(pedimento => {
      pedimento.customs_entry_payment_date = pedimento.customs_entry_payment_date?.substring(0, 10) || 'Sin fecha';
      return pedimento;
    });
  }

  /**
   * Recalcula los totales de toneladas liberadas y piezas (super sacos) de la tabla.
   * @param pedimentos - Lista de pedimentos sobre la cual se calculan los totales.
   */
  updateTotals(pedimentos: Pedimento[]) {
    this.table_config.totals!.total = pedimentos.reduce( (previous, current) => previous + Number(current.tons_released), 0);
    this.table_config.totals!.piezas = pedimentos.reduce( (previous, current) => previous + Number(current.big_bags), 0);
  }

  /**
   * Establece el filtro por tipo de pedimento (todos, activos o inactivos) y reordena la lista.
   * @param types - Código del tipo de filtro a aplicar.
   */
  typesCustom(types: number) {
    this.togleActives = types;
    this.sortCustoms();
  }

  /**
   * Filtra los pedimentos según el estado seleccionado (activos/inactivos) y actualiza los totales.
   */
  sortCustoms() {
    this.pedimentoService.pedimentosFilter = this.pedimentoService.pedimentos.filter( custom => {
      if (this.togleActives === 2) {
        return custom.active === true;
      } else if (this.togleActives === 3) {
        return custom.active === false;
      } else {
        return true;
      }
    });
    this.updateTotals(this.pedimentos);
  }

  /**
   * Ordena ascendentemente un arreglo por la clave indicada.
   * @param array - Arreglo a ordenar.
   * @param key - Propiedad por la cual se ordena.
   * @returns El arreglo ordenado in situ.
   */
  sortArray<T>(array: T[], key: keyof T): T[] {
    return array = array.sort(function (a, b) {
      if (a[key] > b[key]) {
        return 1;
      }
      if (a[key] < b[key]) {
        return -1;
      }
      return 0;
    });
  }
}
